import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { axiosInstance } from '../../axios';
import { AdCreativeDetails, AdCreativesApiResponse } from './types';

export const adCreativeKey = (id: string): readonly unknown[] => ['ad-creative', id];

export const fetchAdCreative = async (id: string): Promise<AdCreativeDetails> => {
  const res = await axiosInstance.get<AdCreativesApiResponse<AdCreativeDetails>>(
    '/v3-getAdCreative',
    { params: { id } },
  );
  return res.data.data;
};

/**
 * Pobranie pojedynczej kreacji ze sceną. Świadomie NIE jest to `useQuery`:
 * scenę ładujemy w reakcji na kliknięcie „otwórz", a nie przy renderze listy,
 * więc potrzebny jest imperatywny strzał. `fetchQuery` daje przy okazji cache,
 * dzięki czemu ponowne otwarcie tej samej kreacji nie pyta backendu.
 */
export const useFetchAdCreative = (): ((id: string) => Promise<AdCreativeDetails>) => {
  const queryClient = useQueryClient();

  return useCallback((id: string) => queryClient.fetchQuery({
    queryKey: adCreativeKey(id),
    queryFn: () => fetchAdCreative(id),
    staleTime: 60_000,
  }), [queryClient]);
};
